"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typestyle_1 = require("typestyle");
var _1 = require("./");
exports.centerColumn = typestyle_1.style({
    width: '80vw',
    maxWidth: '72rem',
    marginLeft: 'auto',
    marginRight: 'auto',
}, _1.forMobile({
    maxWidth: 'calc(100vw - 2rem)',
    marginLeft: '1rem',
    marginRight: '1rem',
    width: '100%',
}));
// deprecated - use centerColumn and apply the flex style if required
// NOTE: this only exists here to aid conversion of any pages that are using
// the SASS template and need to move over with minimal effort
exports.boxLayout = typestyle_1.style({
    display: 'flex',
    flexDirection: 'column',
    width: '80vw',
    maxWidth: '72rem',
    marginLeft: 'auto',
    marginRight: 'auto',
}, _1.forMobile({
    maxWidth: 'calc(100vw - 2rem)',
    marginLeft: '1rem',
    marginRight: '1rem',
    width: '100%',
}));
